import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import ProfileCampaigns from '../pages/ProfileCampaigns.vue';
import CampaignItem from '../components/CampaignItem.vue';

class ProfileCampaignsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }

  init() {
    this.app = createApp(ProfileCampaigns);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6
    });

    this.app.component('campaign-item', CampaignItem);

    this.app.mount(this.container);
  }
}

export default ProfileCampaignsComponent;
